import React, { useEffect } from "react";
import NationalityListing from "./pages/NationalityListing";

function Nationality(props) {
    const { setActive } = props;
    useEffect(() => {
      //setActive(3);
    }, []);

    return <NationalityListing />
};

export default Nationality;